import { IShellEvent } from './IShellEvent';
import { Injectable } from '@angular/core';
import { NavigationInfo, ShellCommunicationEvents } from '@shared/generalInterfaces';
import { ApplicationNavigationService } from '../../shell/application-navigation/application-navigation.service';
@Injectable({ providedIn: 'root' })
export class OpenApplicationEvent implements IShellEvent {
	constructor(private applicationNavigationService: ApplicationNavigationService) {}

	get eventName(): string {
		return ShellCommunicationEvents.OpenApplication;
	}

	handleCustomEvent(event: any): void {
		const transition = {
			navigatedFromAppId: event.data.navigatedFromAppId,
			urlFrom: event.data.urlFrom,
			navigatedToAppId: event.data.navigatedToAppId,
			appMetadata: event.data.appMetadata,
		} as NavigationInfo;

		this.applicationNavigationService.navigate(transition);
	}

	handlePostMessage(event): void {}
}
